/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const DevIngestionStatus = {
    Succeeded: 'Succeeded',
    Running: 'Running',
    Failed: 'Failed'
} as const;
export type DevIngestionStatus = typeof DevIngestionStatus[keyof typeof DevIngestionStatus];


export function instanceOfDevIngestionStatus(value: any): boolean {
    for (const key in DevIngestionStatus) {
        if (Object.prototype.hasOwnProperty.call(DevIngestionStatus, key)) {
            if (DevIngestionStatus[key as keyof typeof DevIngestionStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function DevIngestionStatusFromJSON(json: any): DevIngestionStatus {
    return DevIngestionStatusFromJSONTyped(json, false);
}

export function DevIngestionStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): DevIngestionStatus {
    return json as DevIngestionStatus;
}

export function DevIngestionStatusToJSON(value?: DevIngestionStatus | null): any {
    return value as any;
}

export function DevIngestionStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): DevIngestionStatus {
    return value as DevIngestionStatus;
}

